import { setCloudReportFilters } from '../../Reports/reports.slice'
import { isEmpty } from 'lodash'
import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { selectCloudReportFilters } from '../../Reports/reports.selectors'
import { Input } from '@/components/ui/input'

const StringHeaderFilter = ({ column }) => {
	const dispatch = useDispatch()
	const reportFilters = useSelector(selectCloudReportFilters)

	return (
		<Input
			className={'search-input'}
			placeholder={column.text}
			value={reportFilters[`${column.dataField}`]}
			onChange={(ev) => {
				dispatch(
					setCloudReportFilters({
						...reportFilters,
						[`${column.dataField}`]: isEmpty(ev.target.value)
							? null
							: ev.target.value,
					})
				)
			}}
		/>
	)
}

export default StringHeaderFilter
